import { Icon } from '@chakra-ui/react';

export default function SFDeskclockIcon(props) {
  return (
    <Icon
      width={4}
      height='17px'
      viewBox='0 0 16 17'
      fill='currentColor'
      {...props}
    >
      <path d='M8 16.328c-4.352 0-7.969-3.617-7.969-7.969C.031 4 3.641.391 7.992.391 12.352.39 15.97 4 15.97 8.359c0 4.352-3.61 7.97-7.969 7.97M8 15a6.615 6.615 0 0 0 6.64-6.64 6.62 6.62 0 0 0-6.648-6.641 6.6 6.6 0 0 0-6.625 6.64A6.61 6.61 0 0 0 8 15M5.32 6.445a.535.535 0 0 1 0-.765.54.54 0 0 1 .774 0l1.93 1.945 3.187-3.187c.219-.22.539-.211.766 0a.52.52 0 0 1 0 .765L8.414 8.766a.53.53 0 0 1-.773 0zM.125 12.688c.93 1.687 2.203 2.921 3.914 3.75h-2.5c-.96 0-1.414-.438-1.414-1.383zm15.781 0v2.367c0 .945-.453 1.383-1.414 1.383H12c1.703-.829 2.977-2.063 3.906-3.75' />
    </Icon>
  );
}
